import * as v from 'valibot';

/**
 * Global Russian validator messages, installed once in `main.ts` before the app
 * mounts. Forms then declare only the SHAPE — never a per-call message for a
 * standard validator, or the wording drifts field by field.
 */
export const setupValibotI18n = (): void => {
  v.setGlobalMessage('Неверное значение.');
  v.setSchemaMessage('Поле обязательное.');

  v.setSpecificMessage(v.string, 'Поле обязательное.');
  v.setSpecificMessage(v.number, 'Ожидается число.');
  v.setSpecificMessage(v.boolean, 'Ожидается «да» или «нет».');
  v.setSpecificMessage(v.bigint, 'Ожидается целое число.');
  v.setSpecificMessage(v.date, 'Ожидается дата.');
  v.setSpecificMessage(v.array, 'Ожидается список.');
  v.setSpecificMessage(v.object, 'Ожидается объект.');
  v.setSpecificMessage(v.literal, 'Неверное значение.');
  v.setSpecificMessage(v.picklist, 'Выбери значение из списка.');
  v.setSpecificMessage(v.enum, 'Неверное значение.');
  v.setSpecificMessage(v.union, 'Неверное значение.');

  v.setSpecificMessage(v.nonEmpty, 'Поле обязательное.');
  v.setSpecificMessage(v.email, 'Неверный адрес электронной почты.');
  v.setSpecificMessage(v.url, 'Неверная ссылка.');
  v.setSpecificMessage(v.uuid, 'Неверный UUID.');
  v.setSpecificMessage(v.integer, 'Ожидается целое число.');
  v.setSpecificMessage(v.regex, 'Значение не подходит под формат.');
  v.setSpecificMessage(v.isoDate, 'Неверная дата.');
  v.setSpecificMessage(v.isoDateTime, 'Неверные дата и время.');
  v.setSpecificMessage(v.isoTime, 'Неверное время.');

  v.setSpecificMessage(
    v.minLength,
    (issue) => `Минимальная длина — ${issue.requirement} символов.`,
  );
  v.setSpecificMessage(
    v.maxLength,
    (issue) => `Максимальная длина — ${issue.requirement} символов.`,
  );
  v.setSpecificMessage(
    v.length,
    (issue) => `Длина должна быть ${issue.requirement} символов.`,
  );
  v.setSpecificMessage(
    v.minValue,
    (issue) => `Минимальное значение — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxValue,
    (issue) => `Максимальное значение — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.minSize,
    (issue) => `Минимальное количество элементов — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxSize,
    (issue) => `Максимальное количество элементов — ${issue.requirement}.`,
  );
};
